module.exports = __webpack_public_path__ + "img/anniu3.240039c1.png";